import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DepayTransactions() {
  const formatPrice = (amount, currency)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, currencySign: 'standard' }).format(amount);

    const [transactions, setTransactions] = useState(null);
    const { isLoading: isLoadingtransactions, refetch: gettransactions } = useQuery(
        "depay-transactions",
        async () => {
          return await apiClient.get("/api/depay-transactions");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setTransactions(res.data.transactions);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        gettransactions() 
        if (isLoadingtransactions) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

      const [open2, setOpen2] = React.useState(false);
      const [transactionId, setTransactionId] = useState('');
      const [transactionStatus, setTransactionStatus] = useState('');

      const handleClose2 = () => {
        setOpen2(false);
      };
      const handleToggle2 = () => {
        setOpen2(!open2);
      };


      const { isLoading: isUpdating, mutate: updatetransaction } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-transaction`, {
            transaction_id: transactionId,
            transaction_status: transactionStatus,
          });
          
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
      
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
      
                const event2 = new Event('processed');
                window.dispatchEvent(event2);                
                
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data || err ;
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage.message}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event4 = new Event('processed');
            window.dispatchEvent(event4);
            
          },
        }
      );


  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
            {isLoadingtransactions? 'Loading Transactions...' : 'List of Depay Transactions'}
        
      </Typography>
    <TableContainer component={Paper}>
        
      {transactions !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Blockchain</TableCell>
          <TableCell align="right">Status</TableCell>
          <TableCell align="right">Sender</TableCell>
          <TableCell align="right">Nonce</TableCell>
          
          <TableCell align="right">Receiver</TableCell>
          <TableCell align="right">Token</TableCell>
          <TableCell align="right">Amount</TableCell>
          <TableCell align="right">Local Amount</TableCell>
          <TableCell align="right">Confirmations</TableCell>
          <TableCell align="right">After Block</TableCell>
          <TableCell align="right">uuid</TableCell>
          <TableCell align="right">Edit</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {transactions.map((transaction) => (
          <TableRow
            key={transaction.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {transaction.user.name}
            </TableCell>
            <TableCell align="right">{transaction.user.email}</TableCell>
            <TableCell align="right">{transaction.blockchain}</TableCell>
            <TableCell align="right">{transaction.status}</TableCell>
            <TableCell align="right">{transaction.sender}</TableCell>
            <TableCell align="right">{transaction.nonce}</TableCell>
            <TableCell align="right">{transaction.receiver}</TableCell>
            <TableCell align="right">{transaction.token}</TableCell>
            <TableCell align="right">{transaction.amount}</TableCell>
            <TableCell align="right">{formatPrice(transaction.local_amount, transaction.user.currency)}</TableCell>
            <TableCell align="right">{transaction.confirmations}</TableCell>
            <TableCell align="right">{transaction.after_block}</TableCell>
            
            <TableCell align="right">{transaction.uuid}</TableCell>
            <TableCell align="right"><Button
            onClick={() =>{handleToggle2(); setTransactionId(transaction.id);}} 
             startIcon={<EditIcon />}>Edit Transaction</Button></TableCell>
            <TableCell align="right">{getDate(transaction.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>

    <Dialog
        
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"UPDATE STATUS"}</DialogTitle>
        <DialogContent>
          <Box px={1} sx={{display: 'flex', justifyContent: 'space-evenly'}}>

          <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
            <InputLabel htmlFor="status">status</InputLabel>
                <Select
                    onChange={(e) => setTransactionStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label='status'
                    >
                    <MenuItem selected value=''>
                        select status
                    </MenuItem> 
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value="paid">paid</MenuItem>
                    <MenuItem value="canceled">canceled</MenuItem>
                </Select>
            </FormControl>
          </Box>          
        </DialogContent>
        
        <DialogActions>
            <Button onClick={()=>updatetransaction()} color='error'>{isUpdating? 'Updating...': 'Update Status'}</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}